import { Bird, DollarSign, Headset } from "lucide-react";
import { motion } from "framer-motion";
import { Separator } from "@/components/ui/separator";
import { UpgradeLayout } from "./UpgradeLayout";
import { UpgradeCTA } from "./UpgradeCTA";

const NewSubscription = ({ email, rewardfulReferenceId }) => {
  return (
    <UpgradeLayout>
      <div className="grid grid-cols-1 md:grid-cols-[1fr_2fr] gap-4  h-full">
        <div className="flex gap-4 bg-sky-500 isolate">
          <div className="flex flex-col justify-between p-6 animate-fade-in  justify-self-center w-full">
            <div className="p-6 text-left space-y-6">
              <div>
                <h2 className="text-xl font-semibold text-white">
                  Welcome to SamSearch
                </h2>
                <p className="text-sm text-sky-100 mt-1">
                  SamSearch is the complete solution for your business:
                </p>
              </div>
              <div className="">
                {[
                  { icon: Headset, feature: "Live customer support" },
                  { icon: DollarSign, feature: "30-day money-back guarantee" },
                  { icon: Bird, feature: "Cancel anytime" },
                ].map(({ icon: Icon, feature }) => (
                  <motion.div
                    key={feature}
                    className="flex items-center space-x-3 text-left p-3 rounded-lg"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ duration: 0.5 }}
                  >
                    <Icon className="w-7 h-7 p-1 text-sky-600 flex-shrink-0 rounded-lg bg-sky-300 border border-sky-500" />
                    <span className="text-sm text-gray-100">{feature}</span>
                  </motion.div>
                ))}
              </div>
            </div>
            <UpgradeCTA />
          </div>
          <Separator orientation="vertical" />
        </div>
        <div className="flex flex-col justify-between p-6 animate-fade-in text-center">
          <div>
            <stripe-pricing-table
              pricing-table-id={import.meta.env.VITE_STRIPE_PRICING_TABLE_ID}
              publishable-key={import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY}
              client-reference-id={rewardfulReferenceId}
              customer-email={email}
            />
          </div>
          <p className="text-xs text-center text-gray-500">
            Cancel at any time.
          </p>
        </div>
      </div>
    </UpgradeLayout>
  );
};

export { NewSubscription };
